import type { ApiFlow } from '../types'

/** Same embedded loop as native but client_mode=browser (redirect_to on success). */
export const spaEmbeddedLoginFlow: ApiFlow = {
  id: 'spa.embedded.login',
  appTypes: ['spa'],
  title: 'Embedded login (browser)',
  summary:
    'Render your own login UI and drive the pipeline via /auth/start and /auth/continue. On success the browser receives redirect_to for OAuth completion.',
  steps: [
    {
      id: 'start',
      title: 'Start login',
      when: 'User submits credentials in your embedded form',
      method: 'POST',
      path: '/api/v1/auth/start',
      operationId: 'authStart',
      headers: { 'Content-Type': 'application/json' },
      requestBody: {
        method: 'password',
        identifier: 'user@example.com',
        password: '<user-password>',
        client_mode: 'browser',
        login_challenge: '<from-oauth-redirect-if-applicable>',
      },
      responseVariants: [
        {
          label: 'pending',
          status: 200,
          body: {
            data: {
              status: 'pending',
              flow_id: 'flw_01HXXXXXXXXXXXXXXXXXXXXXX',
              pause: { kind: 'mfa.picker' },
            },
          },
          nextStepId: 'continue',
        },
        {
          label: 'success',
          status: 200,
          body: {
            data: {
              status: 'success',
              redirect_to: '{{REDIRECT_URI}}?code=...&state=...',
            },
          },
        },
      ],
      pauseKinds: ['mfa.picker', 'mfa.verify', 'channel_otp_send', 'captcha'],
    },
    {
      id: 'continue',
      title: 'Continue loop',
      when: 'status was pending',
      method: 'POST',
      path: '/api/v1/auth/continue',
      operationId: 'authContinue',
      requestBody: {
        flow_id: 'flw_01HXXXXXXXXXXXXXXXXXXXXXX',
        client_mode: 'browser',
        code: '123456',
      },
      responseVariants: [
        {
          label: 'pending',
          status: 200,
          body: { data: { status: 'pending', flow_id: 'flw_01HXXXXXXXXXXXXXXXXXXXXXX' } },
          nextStepId: 'continue',
          loop: true,
        },
        {
          label: 'success',
          status: 200,
          body: { data: { status: 'success', redirect_to: '{{REDIRECT_URI}}?code=...' } },
        },
      ],
    },
  ],
}
